export const MATERIAL_TYPES = Object.freeze({
    ELASTIC: 24
})
